import CardDesignerView from './CardDesignerView';

export default CardDesignerView;
